import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { logErrorWithPrefix } from '../service/error-util';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retry(1),
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';

      if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }

      // catch the localities API errors by the component for showing input fields error message
      if (error?.url?.includes('localities')) {
        return throwError(() => error);
      }
      logErrorWithPrefix('HTTP error:', error);
      return throwError(() => errorMessage);
    }),
  );
};
